import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaBars, FaUserCircle, FaSignOutAlt, FaUser, FaPills, FaTruck } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import {
  FaBoxes, FaClipboardList, FaClinicMedical, FaFileInvoice,
  FaFileAlt, FaFileMedical, FaUserCog, FaUsers, FaStoreAlt,
  FaPrescriptionBottleAlt, FaFileMedicalAlt, FaHistory, FaBox, FaBalanceScale,FaRegFileAlt ,
} from "react-icons/fa";
import {
  BsGraphUpArrow,
} from "react-icons/bs";
import { HiDocumentReport } from "react-icons/hi";
import { MdDashboard } from "react-icons/md";
import noProfile from "assets/images/noprofile.png";


const Header = ({ toggleSidebarCollapse}) => {
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");
  const location = useLocation();

  useEffect(() => {
    const nameFromStorage = localStorage.getItem("full_name");
    const roleFromStorage = toCamelCase(localStorage.getItem("role"));

    if (nameFromStorage) setUserName(nameFromStorage);
    if (roleFromStorage) setUserRole(roleFromStorage.charAt(0).toUpperCase() + roleFromStorage.slice(1));
  }, []);
  
  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .trim()
      .split(/[-_\s]+/)
      .map((word, index) =>
        index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join('');
  };
  
  // Fungsi untuk mendapatkan judul halaman berdasarkan path URL
  const getPageTitle = () => {
    const path = location.pathname;
  
    if (path === "/") return "Dashboard";
    
    if (path.startsWith("/transactions")) return "Transaksi";
    if (path === "/enterprise/outlet") return "Outlet";
    if (path === "/enterprise/createoutlet") return "Tambah Outlet";
    if (path.startsWith("/enterprise/editoutlet")) return "Edit Outlet";
  
    if (path === "/enterprise/shift") return "Shift";
    if (path === "/enterprise/createshift") return "Tambah Shift";
    if (path.startsWith("/enterprise/editshift")) return "Edit Shift";
  
    if (path === "/enterprise/karyawan") return "Karyawan";
    if (path === "/enterprise/createkaryawan") return "Tambah Karyawan";
    if (path.startsWith("/enterprise/editkaryawan")) return "Edit Karyawan";
  
    if (path === "/enterprise/karyawan/shiftingkaryawan") return "Shifting Karyawan";
  
    if (path === "/enterprise/distributor") return "Distributor";
    if (path === "/enterprise/createdistributor") return "Tambah Distributor";
    if (path.startsWith("/enterprise/editdistributor")) return "Edit Distributor";
  
    if (path === "/obat-paket/obat") return "Obat";
    if (path === "/obat-paket/obat/create") return "Tambah Obat";
    if (path.startsWith("/obat-paket/obat/edit/:id")) return "Edit Obat";
    if (path.startsWith("/obat-paket/obat/detail/:flag")) return "Detail Obat";
  
    if (path === "/obat-paket/paket/create") return "Tambah Paket Obat";
  
    if (path === "/obat-paket/paket") return "Paket";
    if (path.startsWith("/obat-paket/paket/detail/:name/:outlet")) return "Detail Paket";

    if (path.startsWith("/inventory/stock-opname")) return "Stock Opname";
    if (path === "/inventory/stock-opname/create") return "Tambah Stock Opname";
  
    if (path === "/inventory/purchase-order") return "Daftar Purchase Order";
    if (path.startsWith("/inventory/purchase-order/detail/:poNumber")) return "Detail Purchase Order";
    if (path.startsWith("/inventory/purchase-order/receive/:poNumber")) return "Terima Purchase Order";
    if (path === "/inventory/purchase-order/purchasingorderformadmin") return "Form PO (Admin)";
  
    if (path === "/inventory/invoice") return "Invoice";
    if (path === "/inventory/invoice/create") return "Buat Invoice";
    if (path.startsWith("/inventory/invoice/detail/:invoiceNumber")) return "Detail Invoice";
    if (path.startsWith("/inventory/invoice/form/:poNumber")) return "Invoice dari PO";
    if (path === "/rebalance" || path === "/rebalance") return "Rebalance";
    if (path === "/rebalance/create" || path === "/rebalance/create") return "Buat Rebalance";
    if (path === "/logs" || path === "/logs") return "Logs";
    if (path === "/report/salesreport" || path === "/report/salesreport") return "Sales Report";
    if (path === "/report/monthlyreport" || path === "/report/monthlyreport") return "Monthly Report";
    // if (path === "/enterprise/logsother") return "Log Aktivitas Lainnya";
  
    if (path === "/detailed-report") return "Laporan Detail";
  
    return "Halaman";
  };
  const getPageIcon = () => {
    const path = location.pathname;
  
    if (path === "/")
      return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.5 3.75C1.5 3.15326 1.73705 2.58097 2.15901 2.15901C2.58097 1.73705 3.15326 1.5 3.75 1.5H8.25C8.84674 1.5 9.41903 1.73705 9.84099 2.15901C10.2629 2.58097 10.5 3.15326 10.5 3.75V8.25C10.5 8.84674 10.2629 9.41903 9.84099 9.84099C9.41903 10.2629 8.84674 10.5 8.25 10.5H3.75C3.15326 10.5 2.58097 10.2629 2.15901 9.84099C1.73705 9.41903 1.5 8.84674 1.5 8.25V3.75ZM3.75 3C3.55109 3 3.36032 3.07902 3.21967 3.21967C3.07902 3.36032 3 3.55109 3 3.75V8.25C3 8.44891 3.07902 8.63968 3.21967 8.78033C3.36032 8.92098 3.55109 9 3.75 9H8.25C8.44891 9 8.63968 8.92098 8.78033 8.78033C8.92098 8.63968 9 8.44891 9 8.25V3.75C9 3.55109 8.92098 3.36032 8.78033 3.21967C8.63968 3.07902 8.44891 3 8.25 3H3.75ZM13.5 3.75C13.5 3.15326 13.7371 2.58097 14.159 2.15901C14.581 1.73705 15.1533 1.5 15.75 1.5H20.25C20.8467 1.5 21.419 1.73705 21.841 2.15901C22.2629 2.58097 22.5 3.15326 22.5 3.75V8.25C22.5 8.84674 22.2629 9.41903 21.841 9.84099C21.419 10.2629 20.8467 10.5 20.25 10.5H15.75C15.1533 10.5 14.581 10.2629 14.159 9.84099C13.7371 9.41903 13.5 8.84674 13.5 8.25V3.75ZM15.75 3C15.5511 3 15.3603 3.07902 15.2197 3.21967C15.079 3.36032 15 3.55109 15 3.75V8.25C15 8.44891 15.079 8.63968 15.2197 8.78033C15.3603 8.92098 15.5511 9 15.75 9H20.25C20.4489 9 20.6397 8.92098 20.7803 8.78033C20.921 8.63968 21 8.44891 21 8.25V3.75C21 3.55109 20.921 3.36032 20.7803 3.21967C20.6397 3.07902 20.4489 3 20.25 3H15.75ZM1.5 15.75C1.5 15.1533 1.73705 14.581 2.15901 14.159C2.58097 13.7371 3.15326 13.5 3.75 13.5H8.25C8.84674 13.5 9.41903 13.7371 9.84099 14.159C10.2629 14.581 10.5 15.1533 10.5 15.75V20.25C10.5 20.8467 10.2629 21.419 9.84099 21.841C9.41903 22.2629 8.84674 22.5 8.25 22.5H3.75C3.15326 22.5 2.58097 22.2629 2.15901 21.841C1.73705 21.419 1.5 20.8467 1.5 20.25V15.75ZM3.75 15C3.55109 15 3.36032 15.079 3.21967 15.2197C3.07902 15.3603 3 15.5511 3 15.75V20.25C3 20.4489 3.07902 20.6397 3.21967 20.7803C3.36032 20.921 3.55109 21 3.75 21H8.25C8.44891 21 8.63968 20.921 8.78033 20.7803C8.92098 20.6397 9 20.4489 9 20.25V15.75C9 15.5511 8.92098 15.3603 8.78033 15.2197C8.63968 15.079 8.44891 15 8.25 15H3.75ZM13.5 15.75C13.5 15.1533 13.7371 14.581 14.159 14.159C14.581 13.7371 15.1533 13.5 15.75 13.5H20.25C20.8467 13.5 21.419 13.7371 21.841 14.159C22.2629 14.581 22.5 15.1533 22.5 15.75V20.25C22.5 20.8467 22.2629 21.419 21.841 21.841C21.419 22.2629 20.8467 22.5 20.25 22.5H15.75C15.1533 22.5 14.581 22.2629 14.159 21.841C13.7371 21.419 13.5 20.8467 13.5 20.25V15.75ZM15.75 15C15.5511 15 15.3603 15.079 15.2197 15.2197C15.079 15.3603 15 15.5511 15 15.75V20.25C15 20.4489 15.079 20.6397 15.2197 20.7803C15.3603 20.921 15.5511 21 15.75 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25V15.75C21 15.5511 20.921 15.3603 20.7803 15.2197C20.6397 15.079 20.4489 15 20.25 15H15.75Z"
          fill="#7FB487"/>
      </svg>
        ;
    
    if (path.startsWith("/transactions")) return <FaClipboardList className="text-green-700 text-2xl"/>;
    if (path.includes("outlet")) return <FaStoreAlt className="text-green-700 text-2xl"/>;
    if (path.includes("shiftingkaryawan"))
      return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
          stroke="#7FB487" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path
          d="M19.211 15.74L15.671 19.2801C15.531 19.4201 15.401 19.68 15.371 19.87L15.181 21.22C15.111 21.71 15.451 22.05 15.941 21.98L17.291 21.79C17.481 21.76 17.751 21.63 17.881 21.49L21.421 17.95C22.031 17.34 22.321 16.63 21.421 15.73C20.531 14.84 19.821 15.13 19.211 15.74Z"
          stroke="#7FB487" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.7031 16.25C19.0031 17.33 19.8431 18.17 20.9231 18.47" stroke="#7FB487" stroke-width="1.5"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.41016 22C3.41016 18.13 7.26018 15 12.0002 15C13.0402 15 14.0402 15.15 14.9702 15.43"
              stroke="#7FB487" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>;
    if (path.includes("shift")) return <FaClipboardList className="text-green-700 text-2xl"/>;
    if (path.includes("karyawan")) return <FaUsers className="text-green-700 text-2xl"/>;
    if (path.includes("distributor")) return <FaTruck className="text-green-700 text-2xl"/>;
    if (path.includes("obat")) return <FaPills className="text-green-700 text-2xl"/>;
    if (path.includes("paket")) return <FaBox className="text-green-700 text-2xl"/>;
    // if (path.startsWith("/inventory")) return <FaBoxes className="text-green-700 text-2xl"/>;
    if (path.includes("stock-opname")) return <FaBoxes className="text-green-700 text-2xl"/>;
    if (path.includes("purchase-order")) return <FaRegFileAlt className="text-green-700 text-2xl"/>;
    if (path.includes("invoice")) return <FaFileInvoice className="text-green-700 text-2xl"/>;
    if (path.includes("rebalance")) return <FaBalanceScale className="text-green-700 text-2xl"/>;
    if (path.includes("log")) return <FaHistory className="text-green-700 text-2xl"/>;
    // if (path.includes("report")) return <HiDocumentReport className="text-green-700 text-2xl"/>;
    if (path.includes("salesreport")) return <BsGraphUpArrow className="text-green-700 text-2xl"/>;
    if (path.includes("monthlyreport")) return <BsGraphUpArrow className="text-green-700 text-2xl"/>;
    
    return null;
  };
  
  
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!isUserDropdownOpen);
  };
  // Fungsi untuk logout
  const handleLogout = () => {
    const confirmLogout = window.confirm(
      "Apakah Anda yakin ingin keluar dari aplikasi?"
    );
    if (confirmLogout) {
      localStorage.removeItem("token"); // Hapus token autentikasi dari localStorage
      window.location.href = "/login"; // Redirect ke halaman login
    }
  };
  
  return (
    <header className="sticky top-0 z-20 bg-white shadow px-6 py-4 flex justify-between items-center">
      {/* Kiri: Tombol Sidebar + Judul */}
      <div className="flex items-center space-x-4">
        {/* Tambahkan Icon dan Title */}
        <div className="flex items-center space-x-3">
          {getPageIcon()}
          <h1 className="text-2xl font-medium text-gray-600">{getPageTitle()}</h1>
        </div>
      </div>
      {/* Kanan: Info User */}
      <div className="relative">
        <div
          onClick={toggleUserDropdown}
          className="flex items-center space-x-4">
          <div className="text-sm text-right">
            <p className="font-medium">{localStorage.getItem("full_name")}</p>
            <p className="text-gray-500 text-xs">{userRole}</p>
          </div>
          <img src={noProfile} alt="avatar" className="w-10 h-10 rounded-md shadow-md"/>
        </div>
        
        {/* Dropdown */}
        {isUserDropdownOpen && (
          <div className="absolute right-0 mt-2 w-44 bg-white rounded-lg shadow-lg z-50">
            <ul className="py-1 text-sm text-gray-700">
              <li>
                <button className="flex items-center w-full px-4 py-2 hover:bg-gray-100 transition">
                  <FaUser className="mr-2"/> Profile
                </button>
              </li>
              <li>
                <button
                  onClick={handleLogout}
                  className="flex items-center w-full px-4 py-2 hover:bg-gray-100 transition text-red-600"
                >
                  <FaSignOutAlt className="mr-2"/> Logout
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
